<template>
  <a class="post-thumbnail">
    <div class="post-thumbnail__foreground animation-box__wrapper">
      <div
        class="post-thumbnail__sprite animation-box animation-box--6"
        v-lazy:background-image="require('@/assets/img/sprites/compressed/post-'+id+'.png')"
      ></div>
    </div>
    <div class="post-thumbnail__background">
      <!-- TODO: Linkowanie do postów -->
      <a href="#" class="post-thumbnail__read-more">
        <img
          class="post-thumbnail__arrow post-thumbnail__arrow--primary"
          src="../assets/img/arrow-right.svg"
          alt="read more"
        />
        <img
          class="post-thumbnail__arrow post-thumbnail__arrow--hover"
          src="../assets/img/arrow-two-fingers.svg"
          alt="read more"
        />
      </a>
      <span class="post-thumbnail__title">{{title}}</span>
      <h3 class="post-thumbnail__subtitle" v-html="subtitle"></h3>
    </div>
  </a>
</template>

<script>
export default {
  name: "PostThumbnail",
  props: {
    id: Number,
    title: String,
    subtitle: String,
    img: String
  }
};
</script>

<style lang="scss">
.post-thumbnail {
  position: relative;
  border-bottom: 1px solid $black-color;
  min-height: 270px;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;

  &__foreground {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    opacity: 0;
    overflow: visible;
    transform: translate(6%, -18%) scale(0.9);
    transform-origin: right bottom;
  }

  &__read-more {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__arrow {
    width: 30px;
    height: auto;

    &--hover {
      display: none;
      transform: translateY(1px);
    }
  }

  &__title {
    display: block;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 44px;
    flex-grow: 1;
  }

  &__subtitle {
    font-size: 37px;
    line-height: 1.27;
    letter-spacing: -0.01em;
    padding-bottom: 45px;
    color: $primary-color;
    font-weight: 600;
  }

  &:hover {
    .post-thumbnail__foreground {
      opacity: 1;
    }

    .post-thumbnail__arrow {
      &--hover {
        display: block;
      }

      &--primary {
        display: none;
      }
    }
  }
  @media (max-width: $tablet) {
    &__subtitle {
      padding-bottom: 22px;
    }
  }
}
</style>